export const MAKE_ARTICLES = [];
